export enum BasketItemType {
  HOTEL = 'Hotel',
  FLIGHT = 'Flight',
  TOUR = 'Tour',
  TRANSFER = 'Transfer',
  EXTRA_SERVICE = 'ExtraService',
  BUS = 'Bus',
  SETUR_POINT = 'SeturPoint',
  VEHICLE = 'Vehicle',
}
